import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import type { IDiagnostics } from "../../../models/storeModels/IDiagnostics";
import { logout } from "../../../features/auth";

const initialState: IDiagnostics = {
    currentDiagnosticsSegmentPath: undefined,
    currentDiagnosticsSegmentRoad: undefined,
    currentDiagnosticsSegmentDate: undefined,
    currentDiagnosticsSegmentPosition: undefined,
    currentDiagnosticsSegmentPositionDetails: undefined,
    currentDiagnosticsSegmentExecutor: undefined,
    currentDiagnosticsSegmentLength: undefined,
    currentDefectSegmentStart: undefined,
    currentDefectSegmentEnd: undefined,
    currentDefectSegmentType: undefined,
    currentRoadMeasureResultsType: undefined,
    currentMeasureUnit: undefined,
    currentMeasureAdmissibleValue: undefined,
    currentMeasureLessIsBetterMark: undefined,
    diagnosticsTableStoreValue: undefined
}

export const diagnosticsSlice = createSlice({
    name: 'diagnostics',
    initialState,
    reducers: {
        setCurrentRoadDiagnosticsSegment(state, action: PayloadAction<any>) {
            const { date, position, executor, length, path, road, start, startKmPlus, end, endKmPlus } = action.payload
            state.currentDiagnosticsSegmentDate = date
            state.currentDiagnosticsSegmentPosition = position
            state.currentDiagnosticsSegmentExecutor = executor
            state.currentDiagnosticsSegmentLength = length
            state.currentDiagnosticsSegmentPath = path
            state.currentDiagnosticsSegmentRoad = road
            const positionDetails = {
                positionStart: start,
                positionStartKmPlus: startKmPlus,
                positionEnd: end,
                positionEndKmPlus: endKmPlus,
            }
            state.currentDiagnosticsSegmentPositionDetails = positionDetails
        },
        setCurrentRoadMeasureResultsType(state, action: PayloadAction<any>) {
            state.currentRoadMeasureResultsType = action.payload
        },
        setCurrentDefectSegment(state, action: PayloadAction<any>) {
            const { start, end, type } = action.payload
            state.currentDefectSegmentStart = start
            state.currentDefectSegmentEnd = end
            state.currentDefectSegmentType = type
        },
        setCurrentMeasureUnit(state, action: PayloadAction<any>) {
            state.currentMeasureUnit = action.payload
        },
        setCurrentMeasureAdmissibleValue(state, action: PayloadAction<any>) {
            state.currentMeasureAdmissibleValue = action.payload
        },
        setCurrentMeasureLessIsBetterMark(state, action: PayloadAction<any>) {
            state.currentMeasureLessIsBetterMark = action.payload
        },
        setDiagnosticsTableStoreValue(state, action: PayloadAction<any>) {
            state.diagnosticsTableStoreValue = action.payload
        },
    },
    extraReducers: (builder) => {
        builder.addCase(logout, () => {
            return initialState
        })
    },
})

export const {
    setCurrentRoadDiagnosticsSegment,
    setCurrentRoadMeasureResultsType,
    setCurrentMeasureUnit,
    setCurrentMeasureAdmissibleValue,
    setCurrentMeasureLessIsBetterMark,
    setDiagnosticsTableStoreValue,
    setCurrentDefectSegment
} = diagnosticsSlice.actions
export const diagnosticsReducer = diagnosticsSlice.reducer;
